import {SelectInputOption} from '@ibe.components/common/inputs/select-input-indra/models/select-input-option';

export interface State {
	countryCodes: any;
	countryCodesPrefixOpts: SelectInputOption[];
	countryCodesOpts: SelectInputOption[];
	countryConversionCodes: any;
	countryConversionCodesOpts: SelectInputOption[];
	USAirports: any;
	USStates: any;
	schengenCountryCodes: any;
	euCountryCodes: any;
}

export const initialState: State = {
	countryCodes: null,
	countryCodesPrefixOpts: null,
	countryCodesOpts: null,
	countryConversionCodes: null,
	countryConversionCodesOpts: null,
	USAirports: null,
	USStates: null,
	schengenCountryCodes: null,
	euCountryCodes: null
};
